import {
    USER_LOGOUT, FETCH_ADMIN_PALLETS   }  from "actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [], fetched:false, total:0 };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ADMIN_PALLETS:
            console.log('in FETCH_ADMIN_PALLETS',action.payload );
             return {
                ...state,
                data: action.payload.data,
                total: action.payload.total,
                 fetched:true,
            }


        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}

